import { Col } from '@/app/components/Flex/Flex'
import { Text } from '@/app/components/Text/Text'
import CheckSvg from '@/app/icons/check.svg?react'
import RadioActiveSvg from '@/app/icons/radio-active.svg?react'
import RadioSvg from '@/app/icons/radio.svg?react'
import classNames from 'classnames'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export const RadioInput: FunctionalComponent<{
  type?: 'check' | 'radio'
  value: string
  label: string
  checked?: boolean
  onChange?: (checked: boolean) => void
}> = props => {
  return (
    <label
      class={classNames(styles.root, {
        [styles.active]: props.checked,
      })}
    >
      <Col gap={5}>
        <input
          type={props.type === 'check' ? 'checkbox' : 'radio'}
          value={props.value}
          checked={props.checked}
          onChange={e => props.onChange?.(e.currentTarget.checked)}
          hidden
        />

        <div class={styles.iconWrapper}>
          {props.checked
            ? (props.type === 'radio'
              ? <RadioActiveSvg width={20} height={20} class={styles.radioIcon} />
              : (
                <span class={styles.check}>
                  <CheckSvg width={14} height={14} strokeWidth={3} />
                </span>
              ))
            : (props.type === 'radio'
              ? <RadioSvg width={20} height={20} class={styles.radioIcon} />
              : <span class={styles.check} />)}
        </div>

        <Text>
          {props.label}
        </Text>
      </Col>
    </label>
  )
}
